exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".calendar.component{background:#fff;border:1px solid #dcf7fd;text-align:center;z-index:2}.calendar.component .mo{display:table;width:100%;background:#50d8f5;color:#fff}.calendar.component .mo>div{display:table-cell;padding:1em}.calendar.component .mo .next,.calendar.component .mo .prev{cursor:default}.calendar.component .mo .next.disabled,.calendar.component .mo .prev.disabled{opacity:.5}.calendar.component .mo .stamp{width:100%}.calendar.component .days,.calendar.component .week{display:flex}.calendar.component .days>div,.calendar.component .week>div{flex:1}.calendar.component .days .past,.calendar.component .week .past{opacity:.5}.calendar.component .days{color:#50d8f5;text-decoration:underline;text-transform:uppercase}.calendar.component .days>div{padding:.5em 0}.calendar.component .week>div{padding:.5em}.calendar.component .week>div>div{width:100%;height:100%;border:1px solid #dcf7fd;cursor:default}.calendar.component .week>div.selected>div,.calendar.component .week>div.upcoming>div:hover{background:#50d8f5;color:#fff;cursor:pointer}.calendar.component .week>div.today{color:#50d8f5}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/widgets/calendar.less
 ** module id = 156
 ** module chunks = 0
 **/